import React, { useEffect } from 'react'
import Hero from '../components/features/Hero/Hero'
import AboutSection from '../components/features/About/AboutSection'
import InfographicsSection from '../components/features/Infographics/InfographicsSection'
import ProfessionalSkillsSection from '../components/features/Skills/ProfessionalSkillsSection'
import ExperienceSection from '../components/features/Experience/ExperienceSection'
import CertificationsSection from '../components/features/Certifications/CertificationsSection'
import CompaniesSection from '../components/features/Companies/CompaniesSection'
import ServicesSection from '../components/features/Services/ServicesSection'
import CTASection from '../components/features/CTA/CTASection'

const SPAHome = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth'
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto'
    }
  }, [])

  return (
    <main id="main">
      <section id="home">
        <Hero />
      </section>
      <section id="about">
        <AboutSection />
      </section>
      <InfographicsSection />
      <section id="services">
        <ServicesSection />
      </section>
      <section id="skills">
        <ProfessionalSkillsSection />
      </section>
      <section id="experience">
        <ExperienceSection />
      </section>
      <section id="certifications">
        <CertificationsSection />
      </section>
      <section id="projects">
        <CompaniesSection />
      </section>
      <section id="contact">
        <CTASection />
      </section>
    </main>
  )
}

export default SPAHome
